import { FormProvider } from 'contexts/FormContext';
import FormLayout from 'layouts/FormLayout';

interface FormRouteProps {
  Component: React.ComponentType;
}

const FormRoute: React.FC<FormRouteProps> = ({ Component }) => {
  return (
    <FormProvider>
      <FormLayout>
        <Component />
      </FormLayout>
    </FormProvider>
  );
};

export default FormRoute;